export class ModalOptions {
  additionalClasses:                      string;
  additionalHeaderClasses:                string;
  additionalButtonClasses:        				string;
  animatePosition:												string;
  buttonCopy:                     				string;
  howManyIconsUsed:												number;
  iconClasses:                    				string;
  iconFamily:															string;
  headerIconClass:												string;
  modalId:                        				string;
  modalTranslateCopy:             				string;
  typeOfModal:														string;
  accessibilityReaderOnly:        				boolean;
  modalClickEvent:                				boolean;
  screenReader:  													boolean;
  showIcons:                      				boolean;
  size:                                   string;
  onLoad:                      				    boolean;
  customIcon:                             string;
  showIconsCustom:                        boolean;
  modalName:                              string;

  constructor(options: {
    additionalClasses?:                   string,
    additionalHeaderClasses?:                string,
    accessibilityReaderOnly?: 						boolean,
    additionalButtonClasses?: 						string,
    animatePosition?:											string,
    buttonCopy?: 													string,
    headerIconClass?:											string,
    iconClasses?: 												string,
    iconFamily?:													string,
    modalId?: 														string,
    modalTranslateCopy?: 									string,
    modalClickEvent?: 										boolean,
    screenReader?: 												boolean,
    showIcons?: 													boolean,
    typeOfModal?:													string,
    howManyIconsUsed?:										number,
    size?:                                string,
    onLoad?:                      			  boolean,
    customIcon?:                          string,
    showIconsCustom?:                     boolean,
    modalName?:                           string

  } = {}) {
    this.additionalClasses =              options.additionalClasses || '';
    this.additionalHeaderClasses =        options.additionalHeaderClasses || '';
    this.additionalButtonClasses = 				options.additionalButtonClasses || '';
    this.animatePosition = 								options.animatePosition || 'top';
    this.screenReader = 									!!options.screenReader;
    this.buttonCopy = 										options.buttonCopy || '';
    this.modalId = 												options.modalId || '';
    this.modalTranslateCopy = 						options.modalTranslateCopy || '';
    this.iconClasses = 										options.iconClasses || '';
    this.iconFamily = 										options.iconFamily || '';
    this.typeOfModal =										options.typeOfModal || 'default';
    this.accessibilityReaderOnly = 				!!options.accessibilityReaderOnly;
    this.modalClickEvent = 								!!options.modalClickEvent;
    this.showIcons = 											!!options.showIcons;
    this.howManyIconsUsed =								options.howManyIconsUsed || 0 ;
    this.headerIconClass = 								options.headerIconClass || '';
    this.size =                           options.size || '';
    this.onLoad =										      !!options.onLoad;
    this.customIcon =                     options.customIcon || '';
    this.showIconsCustom =                !!options.showIconsCustom;
    this.modalName =                      options.modalName || '';
  }
}